var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 10.1041L13.3346 18.8907L8.54797 14.1174L6.66797 15.9974L13.3346 22.6641L24.0013 11.9974L22.1213 10.1041ZM16.0013 2.66406C8.6413 2.66406 2.66797 8.6374 2.66797 15.9974C2.66797 23.3574 8.6413 29.3307 16.0013 29.3307C23.3613 29.3307 29.3346 23.3574 29.3346 15.9974C29.3346 8.6374 23.3613 2.66406 16.0013 2.66406ZM16.0013 26.6641C10.108 26.6641 5.33464 21.8907 5.33464 15.9974C5.33464 10.1041 10.108 5.33073 16.0013 5.33073C21.8946 5.33073 26.668 10.1041 26.668 15.9974C26.668 21.8907 21.8946 26.6641 16.0013 26.6641Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/checkSuccess.72c0b6c529d2dae61b67c85860ddc8ef.svg";
export { ForwardRef as ReactComponent };